import { render } from "./UserManagementView.vue?vue&type=template&id=2014ac80&scoped=true"
import script from "./UserManagementView.vue?vue&type=script&lang=js"
export * from "./UserManagementView.vue?vue&type=script&lang=js"

import "./UserManagementView.vue?vue&type=style&index=0&id=2014ac80&scoped=true&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2014ac80"]])

export default __exports__